
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"30","height":"31","viewBox":"0 0 30 31","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_11181_141759)"}},[_c('path',{attrs:{"d":"M15 30.344c8.284 0 15-6.716 15-15 0-8.285-6.716-15-15-15-8.284 0-15 6.715-15 15 0 8.284 6.716 15 15 15z","fill":"#E2E8F0"}}),_c('path',{attrs:{"d":"M13.125 13.469l-7.5 11.25 11.25-7.5-3.75-3.75z","fill":"#fff"}}),_c('path',{attrs:{"d":"M13.125 13.469l3.75 3.75 7.5-11.25-11.25 7.5z","fill":"#F1F5F9"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_11181_141759"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(0 .344)","d":"M0 0h30v30H0z"}})])])])
          )
        }
      }
    